import { render, staticRenderFns } from "./purchaseInfoPayment.vue?vue&type=template&id=84d79f66&"
import script from "./purchaseInfoPayment.vue?vue&type=script&lang=js&"
export * from "./purchaseInfoPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports